import React, { useState, useContext, useEffect } from "react";
import {
  Card,
  Row,
  Col,
  Modal,
  Form,
  Navbar,
  Container,
  Nav,
  Button,
  Table,
} from "react-bootstrap";
import toast from "react-hot-toast";
import { MDBInput } from "mdb-react-ui-kit";
import API from "../../utils/api";
import $ from "jquery";
import moment from "moment";
import { Link } from "react-router-dom";
import PsContext from "../../context";
import { PSListItem } from "../../comp";
import { lettersOnly, integerIndMobile, momentDate } from "../../utils";
import EditSales from "./editSales";
import ViewSales from "./viewSales";

const PlasticSalesReport = (props) => {
  const context = useContext(PsContext);
  const [validated, setValidated] = useState(false);
  const [loading, setIsLoading] = useState(false);
  const [materialData, setMaterialData] = useState([]);
  const [edit, setEdit] = useState([]);
  const [plasticData, setPlasticData] = useState([]);
  const [editModel, setEditModel] = useState(false);
  const [viewModel, setViewModel] = useState(false);
  const [stData, stChangeData] = useState([]);
  const [data, setData] = useState([]);
  const [view, setView] = useState([]);
  const [materialType, setMaterialType] = useState([]);
  const [totalData, setTotalData] = useState([]);
  const [totalAmountData, setTotalAmountData] = useState("");
  const [btnLoading, setBtnLoading] = useState(false);
  const [toDate, setToDate] = useState("");
  const [fromDate, setFromDate] = useState("");

  useEffect(() => {
    listgroupname();
    //listdata();
  }, []);

  const filterChange = (e) => {
    var val = e.target.value;
    if (val == "") {
      setMaterialData(data);
    } else {
      let ndata = data.filter(function (item) {
        return item.group_id == val;
      });
      setMaterialData(ndata);
    }
  };

  const showModel = (item) => {
    listplastic(item);
  };

  const showViewModel = (item) => {
    setView(item);
    setViewModel(true);
  };

  const listplastic = (item) => {
    try {
      setIsLoading(true);
      var form = new FormData();
      form.append("acyear", context.acyear.id);
      form.append("salesid", item.salesid);

      API.post("v1/plastic/listsalesbyid", form).then((res) => {
        if (res["data"].status == "1") {
          var d = res["data"].data;
          setPlasticData(d);
          setIsLoading(false);
          setEdit(item);
          setEditModel(true);
        } else {
          setIsLoading(false);
        }
      });
    } catch (er) {}
  };

  const onDateSearch = (event) => {
    event.preventDefault();
    try {
      setBtnLoading(true);
      API.post("v1/plastic/listsales", $("#filer_Date").serialize()).then(
        (res) => {
          if (res["data"].status == "1") {
            var d = res["data"].data;
            var f = d.map(function (obj) {
              return obj.group_id;
            });
            listmaterial(f);
            setData(d);
            setMaterialData(d);
            setBtnLoading(false);
          } else {
            setData([]);
            setMaterialData([]);
            toast.error("No Data Found", "danger");
            setBtnLoading(false);
          }
        }
      );
    } catch (error) {}
  };

  const listgroupname = () => {
    try {
      setIsLoading(true);
      API.get("v1/group/listgroupplastic").then((res) => {
        if (res["data"].status == "1") {
          var d = res["data"].data;
          stChangeData(d);
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      });
    } catch (error) {
      setIsLoading(false);
    }
  };

  // const listdata = () => {
  // 	try {
  // 		setIsLoading(true);
  // 		var form = new FormData();
  // 		form.append('acyear', context.acyear.id);
  // 		API.post('v1/plastic/listsales', form).then(res => {
  // 			if (res['data'].status == '1') {
  // 				var d = res['data'].data;
  // 				setData(d);
  // 				setMaterialData(d);
  // 				setIsLoading(false);
  // 			}
  // 			else {
  // 				setIsLoading(false);
  // 			}
  // 		});
  // 	}
  // 	catch (error) {
  // 		setIsLoading(false);
  // 	}
  // };

  const listmaterial = (grpId) => {
    console.log(grpId);
    try {
      setIsLoading(true);
      var form = new FormData();
      form.append("acyear", context.acyear.id);
      form.append("from", fromDate);
      form.append("to", toDate);
      form.append("group_id", grpId.join(","));
      form.append("plasticValue", JSON.stringify(materialType));
      API.post("v1/plastic/listmaterialsalesreport", form).then((res) => {
        if (res["data"].status == "1") {
          var d = res["data"].data;
          setTotalData(d);
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      });
    } catch (er) {}
  };

  const onFromChange = (event) => {
    var fromdate = $("#fromdate").val();
    setFromDate(fromdate);
    var toMinDate = moment(fromdate).format("YYYY-MM-DD");
    if (fromdate != "") {
      $("#todate").attr("min", toMinDate);
    }
  };

  const onTodate = (e) => {
    setToDate(e.target.value);
  };

  const valueData = (e) => {
    setMaterialType(e);
  };

  const getTotalValue = (id) => {
    var total = totalData;
    console.log(total);
    var s = total.filter(function (obj) {
      return obj.group_id == id;
    });
    console.log(s);
    var total_amount = 0;
    s.forEach((obj) => {
      total_amount = parseFloat(total_amount) + parseFloat(obj.total_amount);
    });
    return parseFloat(total_amount).toFixed(2);
  };

  const grandTotalQty = () => {
    let s = materialData;
    let total = 0;
    s.map((item) => (total = parseFloat(total) + parseFloat(item.salesKg)));
    if (materialType == "others pcs") {
      return parseInt(total);
    } else {
      return parseFloat(total).toFixed(2);
    }
    //return parseFloat(total).toFixed(2);
  };

  const grandTotalAmount = () => {
    let s = totalData;
    let total = 0;
    s.map(
      (item) => (total = parseFloat(total) + parseFloat(item.total_amount))
    );

    return parseFloat(total).toFixed(2);
  };

  return (
    <>
      <div className="container">
        <Navbar bg="white" expand="md">
          <Container>
            <Navbar.Brand>Sales Report</Navbar.Brand>
          </Container>
        </Navbar>
        <Form
          action=""
          method="post"
          id="filer_Date"
          validated={validated}
          onSubmit={onDateSearch}
          style={{ padding: "0px 10px" }}
        >
          <input type="hidden" name="acyear" value={context.acyear.id} />
          <input
            type="hidden"
            name="plasticValue"
            value={JSON.stringify(materialType)}
          />
          <Row className="mt-3" style={{ margin: "5px" }}>
            <Col md={3}>
              <label>From Date:</label>
              <MDBInput
                type="date"
                id="fromdate"
                name="fromdate"
                onChange={onFromChange}
              />
            </Col>
            <Col md={3}>
              <label>To Date:</label>
              <MDBInput
                type="date"
                id="todate"
                name="todate"
                onChange={onTodate}
              />
            </Col>
            <Col md={2}>
              <label>Material type</label>
              <select
                className="form-control form-control-sm"
                name="material_type"
                onChange={(e) => {
                  valueData(e.target.value);
                }}
                required
              >
                <option value="">Select</option>
                <option value="plastic kg">Plastic (Kg)</option>
                <option value="others kg">Non Plastic (Kg)</option>
                <option value="others pcs">Non Plastic (Piece)</option>
              </select>
            </Col>
            <Col md={1}>
              <Button
                type="submit"
                className="mt-4"
                variant="info"
                size="sm"
                style={{ float: "right" }}
                disabled={btnLoading}
              >
                {btnLoading ? "Please wait.." : "Search"}
              </Button>
            </Col>
            <Col md={2}>
              <label>Filter By Group</label>
              <select
                className="form-control form-control-sm"
                name="group"
                onChange={filterChange}
              >
                <option value="">Group</option>
                {stData.map((user, i) => {
                  return <option value={user.id}>{user.grp_name}</option>;
                })}
              </select>
            </Col>
          </Row>
        </Form>
        <Row className="mt-3" style={{ margin: "5px" }}>
          <Col md={12} className="mt-3">
            {(materialData.length > 0 &&
              materialType.length > 0 &&
              materialType == "plastic kg") ||
            materialType == "others kg" ||
            materialType == "others pcs" ? (
              <Table bordered className="mt-10">
                <thead className="text-center">
                  {materialData.length > 0 ? (
                    <tr>
                      <th>S.No</th>
                      {/* <th>Sales Id</th> */}
                      {/*<th>Sales Date</th> */}
                      <th>Group</th>
                      <th>Quantity</th>
                      {/* <th>Vendor</th> */}
                      <th>Total Amount</th>
                      <th>Manage</th>
                    </tr>
                  ) : (
                    ""
                  )}
                </thead>
                <tbody className="text-center">
                  {materialData.map((item, i) => {
                    return (
                      <tr>
                        <td>{i + 1}</td>
                        {/* <td>{item.salesid}</td> */}
                        {/*<td>{momentDate(item.sales_date, 'DD-MM-YYYY')}</td> */}
                        <td align="left">{item.grp_name}</td>
                        {/* <td align="right">{item.salesKg}</td> */}
                        {materialType == "others pcs" ? (
                          <td align="right">{parseInt(item.salesKg)}</td>
                        ) : (
                          <td align="right">{item.salesKg}</td>
                        )}
                        {/* <td align="left">{item.vendor_name}</td> */}
                        <td align="right">{getTotalValue(item.group_id)}</td>
                        <td>
                          {/*<Button variant="success" size="sm" onClick={() => { showModel(item) }}><i className="fas fa-edit"></i></Button>&emsp;*/}
                          {materialType.length > 0 ? (
                            <Button
                              variant="warning"
                              size="sm"
                              onClick={() => {
                                showViewModel(item);
                              }}
                            >
                              <i className="fas fa-eye"></i>
                            </Button>
                          ) : (
                            <Button
                              variant="warning"
                              size="sm"
                              onClick={() => {
                                showViewModel(item);
                              }}
                              disabled
                            >
                              <i className="fas fa-eye"></i>
                            </Button>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                  {materialData.length > 0 ? (
                    <tr>
                      <td colspan="2">
                        <b>
                          <strong>Total</strong>
                        </b>
                      </td>
                      <td align="right">
                        <b>
                          <strong>{grandTotalQty()}</strong>
                        </b>
                      </td>
                      <td align="right">
                        <b>
                          <strong>{grandTotalAmount()}</strong>
                        </b>
                      </td>
                      <td></td>
                    </tr>
                  ) : (
                    ""
                  )}
                </tbody>
              </Table>
            ) : (
              ""
            )}
          </Col>
        </Row>
        <Modal
          show={editModel}
          size="lg"
          onHide={() => {
            setEditModel(false);
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>Edit Sales</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <EditSales
              data={edit}
              afterFinish={() => {
                setEditModel(false);
              }}
            />
          </Modal.Body>
        </Modal>
        <Modal
          show={viewModel}
          size="lg"
          onHide={() => {
            setViewModel(false);
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>View Sales</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ViewSales
              data={view}
              value={materialType}
              total={totalAmountData}
              from={fromDate}
              to={toDate}
              afterFinish={() => {
                setViewModel(false);
              }}
            />
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default PlasticSalesReport;
